<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
        <NxInputName @update:value="handleInputUpdate('name', $event)" />
        <NxInputClientWApp @update:value="handleInputUpdate('identifier', $event)" />
        <!-- <NxSelectPAAtendimento @update:value="handleSelectUpdate('deptoId', $event)" /> -->
        <div>
          <NxSelectTipoFinalizacao @update:value="handleSelectUpdate('typeFinalization', $event)" />
          <NxInputDateRangeAtendimento
            label="Data de Finalização:"
            @update:InitialValue="handleInputDateUpdate('startDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('endDate', $event, false)"
          />
          <NxInputDateRangeAtendimento
            label="Data Abertura Protocolo:"
            @update:InitialValue="handleInputDateUpdate('protocolStartDate', $event, false)"
            @update:FinalValue="handleInputDateUpdate('protocolEndDate', $event, false)"
          />
        </div>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { NxSelectPAAtendimento, NxSelectTipoFinalizacao, NxSelectResponsavelAtendimento } from '@/components/nexum/components/custom-selects/index.js'
import { NxInputName, NxInputClientWApp, NxInputDateRangeAtendimento } from '@/components/nexum/components/custom-inputs/index.js'
import toogleswitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'

export default {
  name: 'SidebarQuadro',
  components: { SidebarSearch, SearchCollapse, NxSelectPAAtendimento, NxInputName, NxInputClientWApp, NxSelectTipoFinalizacao, toogleswitch, NxSelectResponsavelAtendimento, NxInputDateRangeAtendimento },
  data () {
    return {
      form: {
        name: null,
        deptoId: null,
        identifier: null,
        typeFinalization: null,
        startDate: null,
        endDate: null,
        operatorId: ['all'],
        page: 1,
        pageSize: 12,
        status: 'Finalizado',
        fetchImages: true
      }
    }
  },
  computed: {
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        const encodedForm = Object.keys(this.form).reduce((acc, key) => {
          if (this.form[key]) {
            if (key === 'name') {
              acc[key] = typeof this.form[key] === 'string'
                ? encodeURIComponent(this.form[key]).replace(/20/g, ' ')
                : this.form[key]
            } else {
              // Codifica normalmente para os outros campos
              acc[key] = typeof this.form[key] === 'string'
                ? encodeURIComponent(this.form[key])
                : this.form[key]
            }
          } else {
            acc[key] = this.form[key]
          }
          return acc
        }, {})

        this.$emit('search', encodedForm)
        this.$emit('update-pagination')
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
        this.page = 1
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = [selectedValue]
        return
      }
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : [selectedValue.value]
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        const date = new Date(inputedValue)
        if (fieldName === 'endDate') {
          date.setHours(23, 59, 59, 999)
        }
        this.form[fieldName] = date.toISOString()
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/historico_atendimento/search/SidebarRelatorioAtendimento.vue